import {
  Button,
  Checkbox,
  DraggableWindowHeader,
  TextInput,
} from "@hoylu/client-common";
import React, { type SubmitEventHandler, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteScope } from "../../state/analytics/analytics.actions";
import { selectDashboardSelectedProject } from "../../state/workspaces/projects.selector";
import { cancelDashboardOption } from "../../state/workspaces/workspaces.actions";
import { formatLocalizedMarkup } from "../../utils/format.localized.markup";
import { useI18n } from "../../utils/hooks/use.i18n";
import Styles from "./DropScopeDialog.module.css";
import { Modal } from "./Modal";

export const DropScopeDialog = () => {
  const dispatch = useDispatch();

  const selectedProject = useSelector(selectDashboardSelectedProject);

  const tClose = useI18n("CLOSE_BUTTON.");
  const tConfirmDialog = useI18n("CONFIRMATION_DIALOG.");
  const tDeleteScopeDialog = useI18n("DELETE_SCOPE_DIALOG.");

  const [checked, setChecked] = useState(false);
  const [projectName, setProjectName] = useState("");

  const isValid =
    !!selectedProject?.name && projectName === selectedProject.name && checked;

  const handleCancel = () => dispatch(cancelDashboardOption());

  const submitAction: SubmitEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();

    if (!isValid) {
      return;
    }

    dispatch(deleteScope());
    dispatch(cancelDashboardOption());
  };

  return (
    <Modal>
      <form
        autoComplete="off"
        className={Styles.dialog}
        onSubmit={submitAction}
      >
        <DraggableWindowHeader
          close={tClose("CLOSE")}
          icon="hoylu-ui-icons-trash"
          onClose={handleCancel}
          title={tDeleteScopeDialog("TITLE")}
        />

        <div className={Styles.message}>
          {formatLocalizedMarkup(tDeleteScopeDialog("MESSAGE"))}
        </div>

        <TextInput
          label={tDeleteScopeDialog("CONFIRM_PROJECT_NAME")}
          name="projectName"
          onChange={setProjectName}
          type="text"
          value={projectName}
        />

        <Checkbox checked={checked} onChange={setChecked}>
          {tDeleteScopeDialog("CONFIRM_DELETE")}
        </Checkbox>

        <div className={Styles.footer}>
          <Button onClick={handleCancel} type="negative">
            {tConfirmDialog("CANCEL")}
          </Button>
          <Button disabled={!isValid} formType="submit" type="primary">
            {tDeleteScopeDialog("BUTTON_TEXT")}
          </Button>
        </div>
      </form>
    </Modal>
  );
};
